import React, {FC, useEffect} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import {UseCookiesRequest} from '@/common/components/UseCookiesRequest';
import {AppHeader} from '../AppHeader';
import {AppMain} from '../AppMain';
import {AppFooter} from '../AppFooter';
import '@/feedback/styles/feedback.css';

interface AppProps {
	mode: 'general' | 'ads';
	skin: string;
	domainName: string;
}

export const App: FC<AppProps> = props => {
	const {mode, skin, domainName} = props;
	const t = useLocalizer();

	useEffect(() => {
		document.title = t('documentTitle', {domainName: domainName.toUpperCase()});
	}, []);

	return (
		<div>
			<AppHeader mode={mode} />
			<AppMain mode={mode} skin={skin} />
			<AppFooter />
			{/* <UseCookiesRequest />*/}
		</div>
	);
};

App.displayName = 'App';
